import { Box, Icons, Stack, Typography, tokens } from '@cast/design-system';

type Props = {
  permissions: string[];
};

export const Permissions = ({ permissions }: Props) => {
  return (
    <Stack gap={8} sx={{ pl: 42 }}>
      <Stack direction="row" gap={4} alignItems="center">
        <Icons.Shield size={12} color={tokens.theme.fg.structural.secondary} />
        <Typography variant="L12B" color={tokens.theme.fg.structural.secondary}>
          Permissions required
        </Typography>
      </Stack>

      <Box
        component="ul"
        sx={{
          m: 0,
          pl: 18,
          color: tokens.theme.fg.structural.secondary,
        }}
      >
        {permissions.map((permission) => (
          <Typography
            key={permission}
            component="li"
            variant="P12R"
            color={tokens.theme.fg.structural.secondary}
          >
            {permission}
          </Typography>
        ))}
      </Box>
    </Stack>
  );
};
